var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"mb-4 primary--text display-2 font-weight-bold"},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }